export default "__VITE_ASSET__b9685be8__"